import { lazy, Suspense, useState } from 'react';

const OverallStats = lazy(() =>
  import('pages/OverallStats/OverallStats').then(m => ({ default: m.OverallStats }))
);
const SubjectWiseCharts = lazy(() =>
  import('./Subject/SubjectWiseCharts').then(m => ({ default: m.SubjectWiseCharts }))
);
const ClassWiseCharts = lazy(() =>
  import('./Class/ClassWiseCharts').then(m => ({ default: m.ClassWiseCharts }))
);
const EnitityWiseCharts = lazy(() =>
  import('./Entity/EntityWiseCharts').then(m => ({ default: m.EnitityWiseCharts }))
);
const SubGroupWiseCharts = lazy(() =>
  import('./SubGroup/SubGroupWiseCharts').then(m => ({ default: m.SubGroupWiseCharts }))
);
const SubmodulePerformance = lazy(() =>
  import('./Submodule/SubmodulePerformance').then(m => ({ default: m.SubmodulePerformance }))
);
const PaperCodePerformance = lazy(() =>
  import('./Submodule/PaperCodePerformance').then(m => ({ default: m.PaperCodePerformance }))
);
const SlidesContainer = lazy(() => import('ppt_slides/components/SlidesContainer'));

const tabs = [
  {
    name: 'Overall',
    key: 'overall',
    color: '#75a9d9',
    component: OverallStats,
  },
  {
    name: 'Subject Wise',
    key: 'subject',
    color: '#75a9d9',
    component: SubjectWiseCharts,
  },
  {
    name: 'Class Wise',
    key: 'class',
    color: '#e9769f',
    component: ClassWiseCharts,
  },
  {
    name: 'Entity Wise',
    key: 'entity',
    color: '#72b562',
    component: EnitityWiseCharts,
  },
  {
    name: 'Sub-Group',
    key: 'subGroup',
    color: '#cac55f',
    component: SubGroupWiseCharts,
  },
  {
    name: 'Submodule Wise',
    key: 'subModule',
    color: '#3cacae',
    component: SubmodulePerformance,
  },
  {
    name: 'Paper Code Wise',
    key: 'paperCode',
    color: 'lightgreen',
    component: PaperCodePerformance,
  },
  {
    name: 'Reports',
    key: 'reports',
    color: 'lightgreen',
    component: SlidesContainer,
  },
];

export const CompareMetrics = () => {
  const [currentTab, setCurrentTab] = useState(tabs[0]);
  const onTabSelected = (tab: any) => {
    setCurrentTab(tab);
  };

  const CurrentTabComponent = currentTab.component;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="tab-container">
        {tabs.map((tab) => (
          <div
            className="tab-content"
            key={tab.key}
            onClick={() => onTabSelected(tab)}
            style={{
              borderBottom:
                currentTab === tab ? '1px solid #2467C6' : '1px solid #e8e9ee',
              color: currentTab === tab ? '#2467C6' : '',
            }}
          >
            <span>{tab.name}</span>
          </div>
        ))}
      </div>
      <Suspense fallback={<div style={{ padding: '2rem', textAlign: 'center' }}>Loading...</div>}>
        <CurrentTabComponent />
      </Suspense>
    </div>
  );
};
